import { useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { useSignIn, AuthError , SignInForm  } from '@auth';
import { routes } from '@/shared/routes';
import type { OAuthProvider } from '@auth';

interface SignInPageProps {
  onSwitchToSignUp: () => void;
  onOAuth: (provider: OAuthProvider) => void;
  oauthError: string | null;
}

export default function SignInPage({ onSwitchToSignUp, onOAuth, oauthError }: SignInPageProps) {
  const navigate = useNavigate();
  const intl = useIntl();
  const signIn = useSignIn();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);

    try {
      await signIn.mutateAsync({ email, password });
    } catch (error_) {
      const authError = error_ as AuthError;
      setError(authError.error ?? intl.formatMessage({ id: 'auth.signIn.failed' }));
    }
  };

  return (
    <SignInForm
      email={email}
      password={password}
      error={error}
      oauthError={oauthError}
      isLoading={signIn.isPending}
      onEmailChange={setEmail}
      onPasswordChange={setPassword}
      onSubmit={handleSubmit}
      onOAuth={onOAuth}
      onSwitchToSignUp={onSwitchToSignUp}
      onForgotPassword={() => navigate(routes.app.passwordReset)}
    />
  );
}
